import { useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X } from "lucide-react";

const LINKS = [
  { label: "Services", href: "#services", testId: "nav-link-services" },
  { label: "Ecosystem", href: "#ecosystem", testId: "nav-link-ecosystem" },
  { label: "Why Us", href: "#why-us", testId: "nav-link-why-us" },
  { label: "Knowledge", href: "#knowledge", testId: "nav-link-knowledge" },
  { label: "Connect", href: "/connect", testId: "nav-link-connect" },
  { label: "Resources", href: "/resources", testId: "nav-link-resources" },
  { label: "Regional", href: "#regional", testId: "nav-link-regional" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);

  return (
    <header className="fixed top-0 left-0 right-0 z-50 border-b border-[#0B3C5C]/10 bg-white/75 backdrop-blur-xl">
      <div className="mx-auto flex h-[72px] max-w-7xl items-center justify-between px-4 sm:px-6 lg:px-8">
        <a href="#top" data-testid="nav-logo" className="group flex shrink-0 items-center">
          <img
            src="/logo.png"
            alt="Healthcare Solutions"
            className="h-12 w-auto transition-transform duration-300 group-hover:scale-[1.03]"
          />
        </a>

        <nav className="hidden items-center gap-4 xl:flex 2xl:gap-7">
          {LINKS.map((link) => (
            <a
              key={link.href}
              href={link.href}
              data-testid={link.testId}
              className="font-mono-x whitespace-nowrap text-[11px] uppercase tracking-[0.15em] text-[#4A6B82] transition-colors duration-300 hover:text-[#4C8F2F] 2xl:text-xs 2xl:tracking-[0.2em]"
            >
              {link.label}
            </a>
          ))}
          <Link
            to="/admin"
            data-testid="nav-link-admin"
            className="font-mono-x whitespace-nowrap text-[11px] uppercase tracking-[0.15em] text-[#6B8AA0] transition-colors duration-300 hover:text-amber-500 2xl:text-xs 2xl:tracking-[0.2em]"
          >
            Admin
          </Link>
        </nav>

        <button
          data-testid="nav-mobile-toggle"
          onClick={() => setOpen(!open)}
          className="rounded-lg p-2 text-[#33586F] xl:hidden"
          aria-label="Toggle menu"
        >
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>

      {open && (
        <div className="border-t border-[#0B3C5C]/10 bg-white/95 backdrop-blur-xl xl:hidden">
          <div className="flex flex-col gap-1 px-4 py-4">
            {LINKS.map((link) => (
              <a
                key={link.href}
                href={link.href}
                data-testid={`${link.testId}-mobile`}
                onClick={() => setOpen(false)}
                className="rounded-lg px-3 py-3 text-sm font-medium text-[#33586F] transition-colors hover:bg-[#0B3C5C]/5 hover:text-[#4C8F2F]"
              >
                {link.label}
              </a>
            ))}
            <Link
              to="/admin"
              data-testid="nav-link-admin-mobile"
              onClick={() => setOpen(false)}
              className="rounded-lg px-3 py-3 text-sm font-medium text-[#4A6B82] hover:bg-[#0B3C5C]/5 hover:text-amber-500"
            >
              Admin
            </Link>
            <a
              href="#enquiry"
              data-testid="nav-cta-consultation-mobile"
              onClick={() => setOpen(false)}
              className="mt-2 rounded-full bg-[#5FA832] px-6 py-3 text-center text-sm font-semibold text-white"
            >
              Request a Consultation
            </a>
          </div>
        </div>
      )}
    </header>
  );
};
